export const navConfig = [

  {
    title: '▸ Coffee Beans',
    path: '/coffee-beans',
  },

  {
    title: '▸ Espresso Basics',
    path: '/espresso',
  },

  {
    title: '▸ How to Brew coffee',
    path: '/brewing-pages',
  },
  
  { title: 'Other parts', disabled: true },
  { title: 'Home', path: '/' },
  { title: 'About', path: '/about' },
  { title: 'Contact', path: '/contact' },
];
